<template>
  <div
      class="footer"
  >
    <v-btn text small>{{ $t('msg.feedback') }}</v-btn>
    <span>Smarthome &copy; {{ year }}</span>
  </div>
</template>

<script>
  export default {
    data: () => ({
      year: new Date().getFullYear()
    }),
  }
</script>

<style lang="scss">
  .footer {
    width: 100%;
    background-color: #f4f7f9 !important;
    color: #94a3b8;
    font-size: 13px;
    padding: 10px 20px 10px 10px;
    border-top: 1px solid #e2e8f0 !important;
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .v-btn__content {
      font-weight: normal;
      font-size: 10px;
    }
  }
</style>
